export const checkAMLob = () => {
  if (window.reactGlobals && window.reactGlobals.amLob && typeof window.reactGlobals.amLob === "string") {
    return window.reactGlobals.amLob.toLowerCase();
  }
  return "";
};
